export default function HeroSection() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5544999957005', '_blank');
  };

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-[140px] md:pt-24">
      {/* Dark Petrol Blue Background */}
      <div className="absolute inset-0 w-full h-full bg-primary"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight break-words">
          Venda para o Governo com Segurança e Estratégia
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
          Consultoria especializada em licitações públicas com visão 360º: experiência interna + expertise jurídica
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={handleWhatsAppClick}
            className="px-8 py-4 bg-accent text-primary font-semibold rounded-lg hover:bg-accent/90 hover:scale-105 transition-all duration-300 text-lg whitespace-nowrap cursor-pointer"
          >
            Falar no WhatsApp
          </button>
          <button 
            onClick={scrollToServices}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg border-2 border-white/30 hover:bg-white/20 hover:scale-105 transition-all duration-300 text-lg whitespace-nowrap cursor-pointer"
          >
            Saiba Mais
          </button>
        </div>
      </div>
    </section>
  );
}